export default function() {
   return {
      zips: [],
      loaded: false,
   };
}
